// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import getPrivilegeList from "../PrivilegeList.jsx";

// /* ===== IMPORT LIST PAGES ===== */
// import Company from "./Company.jsx";
// import Branch from "./Branch.jsx";
// import Agent from "./Agent.jsx";

// const User = () => {
//   const navigate = useNavigate();
//   const privilegeList = getPrivilegeList();

//   /* ===================== ACTIVE TAB ===================== */
//   const [activeTab, setActiveTab] = useState(() => {
//     if (privilegeList.companyTabView) return "COMPANY";
//     if (privilegeList.branchTabView) return "BRANCH";
//     if (privilegeList.agentTabView) return "AGENT";
//     return "";
//   });

//   /* ===================== ADD BUTTON ===================== */
//   const handleAddClick = () => {
//     if (activeTab === "COMPANY" && privilegeList.companyAdd) {
//       navigate("/company/add");
//     }
//     if (activeTab === "BRANCH" && privilegeList.branchAdd) {
//       navigate("/branch/add");
//     }
//     if (activeTab === "AGENT" && privilegeList.agentAdd) {
//       navigate("/agent/add");
//     }
//   };

//   /* ===================== PAGE CONTENT ===================== */
//   const renderPage = () => {
//     switch (activeTab) {
//       case "COMPANY":
//         return <Company />;
//       case "BRANCH":
//         return <Branch />;
//       case "AGENT":
//         return <Agent />;
//       default:
//         return (
//           <div className="alert alert-warning">
//             You do not have permission to view any module.
//           </div>
//         );
//     }
//   };

//   /* ===================== SHOW ADD BUTTON ===================== */
//   const showAddButton =
//     (activeTab === "COMPANY" && privilegeList.companyAdd) ||
//     (activeTab === "BRANCH" && privilegeList.branchAdd) ||
//     (activeTab === "AGENT" && privilegeList.agentAdd);

//   return (
//     <div className="container-fluid">
//       {/* ===================== HEADER ===================== */}
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h4 className="mb-0">User</h4>

//         {showAddButton && (
//           <button
//             className="btn btn-primary btn-sm"
//             onClick={handleAddClick}
//           >
//             <i className="bi bi-plus-lg me-1"></i>
//             Add {activeTab.charAt(0) + activeTab.slice(1).toLowerCase()}
//           </button>
//         )}
//       </div>

//       {/* ===================== TABS ===================== */}
//       <ul className="nav nav-tabs mb-3">
//         {privilegeList.companyTabView && (
//           <li className="nav-item">
//             <button
//               className={`nav-link ${activeTab === "COMPANY" ? "active" : ""}`}
//               onClick={() => setActiveTab("COMPANY")}
//             >
//               <i className="bi bi-building me-1"></i> Company
//             </button>
//           </li>
//         )}

//         {privilegeList.branchTabView && (
//           <li className="nav-item">
//             <button
//               className={`nav-link ${activeTab === "BRANCH" ? "active" : ""}`}
//               onClick={() => setActiveTab("BRANCH")}
//             >
//               <i className="bi bi-geo-alt me-1"></i> Branch
//             </button>
//           </li>
//         )}

//         {privilegeList.agentTabView && (
//           <li className="nav-item">
//             <button
//               className={`nav-link ${activeTab === "AGENT" ? "active" : ""}`}
//               onClick={() => setActiveTab("AGENT")}
//             >
//               <i className="bi bi-person-workspace me-1"></i> Agent
//             </button>
//           </li>
//         )}
//       </ul>

//       {/* ===================== LIST PAGE ===================== */}
//       {renderPage()}
//     </div>
//   );
// };

// export default User;

import React, { useState } from "react";
import getPrivilegeList from "../PrivilegeList.jsx";

/* ===== IMPORT LIST PAGES ===== */
import Company from "./Company.jsx";
import Branch from "./Branch.jsx";
import Agent from "./Agent.jsx";

const User = () => {
  const privilegeList = getPrivilegeList();

  /* ===================== ACTIVE TAB ===================== */
  const [activeTab, setActiveTab] = useState(() => {
    if (privilegeList.companyTabView) return "COMPANY";
    if (privilegeList.branchTabView) return "BRANCH";
    if (privilegeList.agentTabView) return "AGENT";
    return "";
  });

  /* ===================== PAGE CONTENT ===================== */
  const renderPage = () => {
    switch (activeTab) {
      case "COMPANY":
        return <Company />;
      case "BRANCH":
        return <Branch />;
      case "AGENT":
        return <Agent />;
      default:
        return (
          <div className="alert alert-warning">
            You do not have permission to view any module.
          </div>
        );
    }
  };

  return (
    <div className="container-fluid">
      {/* ===================== TABS ===================== */}
      <ul className="nav nav-tabs mb-3">
        {privilegeList.companyTabView && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "COMPANY" ? "active" : ""}`}
              onClick={() => setActiveTab("COMPANY")}
            >
              <i className="bi bi-building me-1"></i> Company
            </button>
          </li>
        )}

        {privilegeList.branchTabView && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "BRANCH" ? "active" : ""}`}
              onClick={() => setActiveTab("BRANCH")}
            >
              <i className="bi bi-geo-alt me-1"></i> Agency
            </button>
          </li>
        )}

        {privilegeList.agentTabView && (
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "AGENT" ? "active" : ""}`}
              onClick={() => setActiveTab("AGENT")}
            >
              <i className="bi bi-person-workspace me-1"></i> Agent
            </button>
          </li>
        )}
      </ul>

      {/* ===================== LIST PAGE ===================== */}
      {renderPage()}
    </div>
  );
};

export default User;